import { Injectable } from '@angular/core';
import { Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class MachineInfoService {
  getMachineInfo(): Observable<any> {
    return new Observable(observer => {
      const listener = (event: MessageEvent) => {
        if (event.data.type === 'MACHINE_INFO') {
          window.removeEventListener('message', listener);
          if (event.data.response.success) {
            observer.next(event.data.response.data);
            observer.complete();
          } else {
            observer.error(event.data.response.error);
          }
        }
      };

      window.addEventListener('message', listener);

      window.postMessage({ type: 'GET_MACHINE_INFO' }, '*');

      return () => {
        window.removeEventListener('message', listener);
      };
    });
  }
}
